import React from "react";
import { InboxIcon } from "@heroicons/react/outline";

/**
 * Friendly empty placeholder: centered icon + title + optional hint/action.
 */
function EmptyState({ icon: Icon = InboxIcon, title, hint, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-fairblue-100">
        <Icon className="h-8 w-8 text-fairblue-500" aria-hidden="true" />
      </div>
      <h3 className="mt-4 text-lg font-medium text-gray-900">{title}</h3>
      {hint && <p className="mt-1 text-sm text-gray-500">{hint}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export default EmptyState;
